import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { TopCasinosSection } from './components/TopCasinosSection';
import { MobileCasinoSection } from './components/MobileCasinoSection';
import { InfoBlocksSection } from './components/InfoBlocksSection';
import { PaymentMethodsSection } from './components/PaymentMethodsSection';
import { FAQSection } from './components/FAQSection';
import { MobileAppsSection } from './components/MobileAppsSection';
import { NewsSection } from './components/NewsSection';
import { BonusCalculatorSection } from './components/BonusCalculatorSection';
import { CTASection } from './components/CTASection';
import { ProvidersSection } from './components/ProvidersSection';
import { CasinoQuizSection } from './components/CasinoQuizSection';
import { TournamentsSection } from './components/TournamentsSection';
import { GamblingHistorySection } from './components/GamblingHistorySection';
import { GlossarySection } from './components/GlossarySection';
import ReviewsSection from './components/ReviewsSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <StatsSection />
      <TopCasinosSection />
      <MobileCasinoSection />
      <ProvidersSection />
      <CasinoQuizSection />
      <TournamentsSection />
      <ReviewsSection />
      <InfoBlocksSection />
      <PaymentMethodsSection />
      <FAQSection />
      <MobileAppsSection />
      <GamblingHistorySection />
      <NewsSection />
      <BonusCalculatorSection />
      <GlossarySection />
      <CTASection />
    </div>
  );
};

export default HomePage;
